import "./StoreList.scss";

import React from "react";
import { Link } from "react-router-dom";
import request from "request"
import usesFeatures from 'usesFeatures'
import { ApplicationContext } from "ApplicationContext"

import Header from 'Header'

class StoreList extends React.Component {
  static contextType = ApplicationContext

  state = {
    dragIndex: null,
    dragOverIndex: null,
  }

  componentDidMount() {
    this.props.fetchData("venue_admin/stores")
  }

  toggleAllStores = (open) => {
    request.post("venue_admin/stores/toggle", { open })
      .then(() => this.props.fetchData("venue_admin/stores"))
  }

  onDragStart = (index) => {
    this.setState({ dragIndex: index })
  }

  onDragOver = (index, e) => {
    e.preventDefault()
    if (this.state.dragOverIndex !== index) {
      this.setState({ dragOverIndex: index })
    }
  }

  onDragEnd = () => {
    this.setState({ dragIndex: null, dragOverIndex: null })
  }

  onDrop = (dropIndex) => {
    const { stores } = this.props
    const { dragIndex } = this.state

    this.setState({ dragIndex: null, dragOverIndex: null })

    if (dragIndex === null || dragIndex === dropIndex) return

    const reordered = [...stores]
    const [moved] = reordered.splice(dragIndex, 1)
    reordered.splice(dropIndex, 0, moved)

    request.post("venue_admin/stores/reorder", { order: reordered.map(s => s.id) })
      .then(() => this.props.fetchData("venue_admin/stores"))
  }

  render() {
    if (!this.props.dataFetched) return false

    const { stores } = this.props
    const { dragIndex, dragOverIndex } = this.state
    const { user } = this.context.CurrentUserContext

    return(
      <div className="StoreList">
        <Header text={`Stores at ${ this.props.venue.name }`} />
        <div className="block">
          <div className="Table block">
            <div className="datatable-toolbar">
              <div className="actions field">
                <span className="button h-button is-success" onClick={() => this.toggleAllStores(true)}>Open all</span>
                <span className="button h-button is-danger ml-4" onClick={() => this.toggleAllStores(false)}>Close all</span>
              </div>
              <div className="buttons">
                { user.type !== "vendor" &&
                  <Link to="/stores/new" className="button h-button is-primary is-raised">
                    <span className="icon"><i aria-hidden="true" className="fas fa-plus"></i></span>
                    <span>New Store</span>
                  </Link>
                }
              </div>
            </div>
            <div className="table-wrapper">
              <table className="table is-fullwidth is-datatable">
                <thead>
                  <tr className="has-text-left">
                    <th className="drag-handle-col"></th>
                    <th>Store Name</th>
                    <th>Open?</th>
                    <th>All-inclusive?</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  { stores.length === 0 ? (
                    <tr>
                      <td colSpan={5} className="is-italic has-text-centered">
                        No Store Found. Time to <Link to="/stores/new">create one</Link>?
                      </td>
                    </tr>
                  ) : stores.map((store, index) => {
                    const isDragOver = dragOverIndex === index && dragIndex !== index
                    return (
                      <tr
                        key={store.id}
                        draggable
                        onDragStart={() => this.onDragStart(index)}
                        onDragOver={(e) => this.onDragOver(index, e)}
                        onDrop={() => this.onDrop(index)}
                        onDragEnd={this.onDragEnd}
                        className={isDragOver ? "drag-over" : ""}
                      >
                        <td className="drag-handle-col">
                          <span className="drag-handle" title="Drag to reorder">
                            <i className="fas fa-grip-vertical"></i>
                          </span>
                        </td>
                        <td><Link to={`/stores/${store.id}`}>{store.name}</Link></td>
                        <td className="is-narrow">
                          <span className={`storestatus ${store.open ? "open" : "closed"}`}>
                            { store.open ? "Open" : "Closed" }
                          </span>
                        </td>
                        <td>{ store.allInclusive ? "Yes" : "No" }</td>
                        <td className="is-narrow"><Link to={`/stores/${store.id}/edit`}>Edit</Link></td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default usesFeatures(['data'], StoreList)
